// extracted by mini-css-extract-plugin
export default {"wrap":"qp-z","fullWidth":"rp-z","items":"sp-z","featureCss":"tp-z","disabled":"up-z","imgCss":"vp-z"};